import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Loading = _resolveComponent("Loading");
  const _component_b_card = _resolveComponent("b-card");
  const _component_b_modal = _resolveComponent("b-modal");
  const _component_b_button = _resolveComponent("b-button");
  return $props.record && $props.record.id ? (_openBlock(), _createBlock(_component_b_button, {
    key: 0,
    onClick: _cache[1] || (_cache[1] = _withModifiers($event => $data.openModal = true, ["prevent"]))
  }, {
    default: _withCtx(() => [_renderSlot(_ctx.$slots, "default"), _createVNode(_component_b_modal, {
      modelValue: $data.openModal,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $data.openModal = $event),
      id: "credit-card-delete-modal",
      size: "md",
      "no-stacking": "",
      title: "Delete Payment Information",
      focus: "cancel",
      "ok-variant": "danger",
      onOk: $options.deleteCreditCard
    }, {
      default: _withCtx(() => [_createVNode(_component_Loading, {
        loading: $data.loading
      }, null, 8, ["loading"]), !$data.loading ? (_openBlock(), _createBlock(_component_b_card, {
        key: 0
      }, {
        default: _withCtx(() => [...(_cache[2] || (_cache[2] = [_createElementVNode("h4", null, "Are you sure you want to delete this billing information?", -1)]))], undefined, true),
        _: 1
      })) : _createCommentVNode("", true)], undefined, true),
      _: 1
    }, 8, ["modelValue", "onOk"])], undefined, true),
    _: 3
  })) : _createCommentVNode("", true);
}